import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import createFragment from 'react-addons-create-fragment';
import { browserHistory } from 'react-router';
import Helmet from 'react-helmet';
import _ from 'lodash';
import { getThemesV2, resetThemes, getThemesFiltering, onResetThemeKey } from '../../actions/website/ThemeActions';
import PreauthIntro from './components/PreauthIntro';
import { showModal } from '../../actions/ModalActions';
import { createWeddingForRegistryAccountUser } from '../../actions/WeddingActions';
import { signout } from '../../actions/AuthActions';
import ThemesIntro from './components/ThemesIntro';
import ThemesFilter from '../../components/manage/website/ThemesFilter';
import ThemeGroup from '../../components/manage/website/ThemeGroup';
import { callToAction } from '../../actions/PreauthActions';
import BrandGrid from '../preauth/components/BrandGrid';
import MainFooter from '../../components/common/footer/MainFooter';
import scrollViewTo from '../../util/scrollViewTo';
import FooterCtaSection from '../preauth/components/FooterCtaSection';
import { getClearClass } from '../../components/util/themeClearClass';
import { trackOnboardingStarted } from '../../util/trackingHelper';
import { setCookie, setLocalStorage } from '../../util/storage';

/* css imports */
import '../../stylesheets/core.less';
import '../../stylesheets/pages/preauth/components/WebsiteNavOld.less';

const trackOnboardingStartedOnce = _.once(trackOnboardingStarted);

class Themes extends Component {
  constructor(props) {
    super(props);
    const { onboard } = this.props;
    this.state = {
      offset: 0,
      onboardActive: onboard,
      filterOptions: {},
    };
    this.getMoreThemes = this.getMoreThemes.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
  }

  componentDidMount() {
    const scrollToAnchor = () => {
      const { currentThemeKey, themeGroupKey } = this.props;
      const scrollElement = currentThemeKey;
      const backUpScrollElement = themeGroupKey;
      if (scrollElement) {
        const el = document.getElementById(scrollElement);
        if (el) {
          this.scrollTo(el);
        } else if (!el) {
          const themeGroupEl = document.getElementsByClassName(backUpScrollElement)[0];
          this.scrollTo(themeGroupEl);
        }
      }
    };
    setTimeout(scrollToAnchor, 10);
  }

  onFilterChange(filters) {
    const { filterThemes, loadThemes, unloadThemes } = this.props;
    unloadThemes();
    this.setState({
      filterOptions: filters,
      offset: 0
    }, () => {
      filterThemes(this.state.filterOptions.selectedColorKeys, this.state.filterOptions.hasMatchingInvitation);
      loadThemes(this.state.offset);
    });
  }

  getMoreThemes() {
    if (this.props.themes.busy) {
      return;
    }
    const { loadThemes } = this.props;
    this.setState({ offset: this.state.offset + 10 });
    loadThemes(this.state.offset);
  }

  scrollTo(el) {
    const { resetThemeKey } = this.props;
    if (el) {
      scrollViewTo(el);
      window.scrollBy(0, -84);
      resetThemeKey();
    }
  }

  render() {
    const {
      themes,
      onboard,
      userContext,
      onCtaClick,
      scrollIntoView
    } = this.props;
    const resultCount = themes.result_count;
    const themeGroups = themes.theme_group_views;
    const themeList = [];

    if (themeGroups) {
      themeGroups.map((themeGroup, idx) => (
        themeList.push(
          createFragment({
            tile: <ThemeGroup themeGroup={themeGroup} onboard={onboard} scrollIntoView={scrollIntoView} />,
            clearFix: getClearClass(idx)
          })
        )
      ));
    }

    // Fire the onboarding started event only if the user is logged in.
    if ((onboard === true) && !userContext.is_guest) {
      setTimeout(trackOnboardingStartedOnce('WEDDINGS', 'WEDDING_WEBSITE'));
    }

    return (
      <div>
        <Helmet
          defaultTitle="Free Wedding Website Finished Design Templates | Start Here"
          meta={[
            {
              name: 'description',
              content: 'Zola will do anything for love and is reinventing wedding planning by bringing together your wedding website, registry, checklist and guest list.'
            },
            {
              name: 'keywords',
              content: 'Wedding, Wedding Registry, Honeymoon Fund, Wedding Planning, Guest List, Wedding Checklist, Wedding Website, Free wedding website'
            },
            {
              name: 'og:title',
              content: 'Free Wedding Website Finished Design Templates | Start Here'
            },
            {
              name: 'og:description',
              content: 'Zola will do anything for love and is reinventing wedding planning by bringing together your wedding website, registry, checklist and guest list.'
            },
            {
              name: 'og:image',
              content: 'https://www.zola.com/images/favicon/apple-touch-icon-180x180.png'
            }
          ]}
        />
        <div id="themes">
          <div className="theme-page container-fluid">
            <div className="theme-row">
              <PreauthIntro>
                <ThemesIntro onCtaClick={onCtaClick} isGuest={userContext.is_guest} />
              </PreauthIntro>
              <div className="below-fold-container">
                <div className="filter-container" id="themes-filter-container">
                  <ThemesFilter onFilterChange={this.onFilterChange} />
                </div>
                <div className="col-md-10 col-lg-10 col-lg-offset-0 scroll-container">
                  <div id="themes-container">
                    {resultCount > 0 &&
                      <div className="result-count"><p className="sans-text">{resultCount} Design{resultCount !== 1 ? 's' : null}</p></div>
                    }
                    {themes &&
                      <InfiniteScroll loadMore={this.getMoreThemes} hasMore={this.state.offset < resultCount} initialLoad={false} threshold={20}>
                        {themeList}
                      </InfiniteScroll>
                      }
                  </div>
                </div>
              </div>
            </div>
            <div className="sticky-sign-up visible-xs" role="button" onClick={onCtaClick}>
              {userContext.is_guest &&
                <span>Sign Up (It&#8217;s Free!)</span>
              }
              {!userContext.is_guest &&
                <span>Get Started (It&#8217;s Free!)</span>
              }
            </div>
          </div>
          <div>
            <BrandGrid />
            {userContext.is_guest && <FooterCtaSection heading={'Let’s Do This'} />}
          </div>
          <MainFooter />
        </div>
      </div>
    );
  }
}

Themes.propTypes = {
  themes: PropTypes.shape({
    theme_group_views: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
    color_options: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
    selected_color_keys: PropTypes.array,
    resultCount: PropTypes.number,
    limit: PropTypes.number,
    offset: PropTypes.number,
    busy: PropTypes.bool
  }),
  loadThemes: PropTypes.func.isRequired,
  filterThemes: PropTypes.func.isRequired,
  unloadThemes: PropTypes.func.isRequired,
  onboard: PropTypes.bool,
  userContext: PropTypes.shape({}),
  onCtaClick: PropTypes.func.isRequired,
  scrollIntoView: PropTypes.func,
  currentThemeKey: PropTypes.string,
  resetThemeKey: PropTypes.func.isRequired,
  themeGroupKey: PropTypes.string
};

const mapStateToProps = state => (
  {
    themes: state.website.themeListing,
    onboard: !state.wedding.account.disable_website_onboarding,
    userContext: state.user.userContext,
    currentThemeKey: state.website.themeListing.themeKey ? state.website.themeListing.themeKey : null,
    themeGroupKey: state.website.themeListing.themeGroupKey ? state.website.themeListing.themeGroupKey : null,
  }
);

const mapDispatchToProps = dispatch => (
  {
    loadThemes: (offset) => {
      dispatch(getThemesV2(offset));
    },
    filterThemes: (selectedColorKeys, hasMatchingInvitation) => {
      dispatch(getThemesFiltering(selectedColorKeys, hasMatchingInvitation));
    },
    unloadThemes: () => dispatch(resetThemes()),
    onCtaClick: () => {
      setLocalStorage('blockOnboardStartTracking', 'website');
      setCookie('blockOnboardStartTracking', 'website');
      dispatch(callToAction('website'));
    },
    openModal: (modalType, modalProps, modalOptions) => {
      dispatch(showModal(modalType, modalProps, modalOptions));
    },
    showVideo: () => {
      const video = { video: 'aBqthnJ08JQ', autoplay: true };
      dispatch(showModal('VIDEO', { video, className: 'iframe-responsive', hideClose: true }, { size: 'video' }));
    },
    onCreateWeddingAccount: () => dispatch(createWeddingForRegistryAccountUser()).then(() => browserHistory.push('/wedding/manage')),
    onLogOut: () => {
      dispatch(signout()).then(() => window.location.reload());
    },
    resetThemeKey: () => dispatch(onResetThemeKey()),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Themes);



/** WEBPACK FOOTER **
 ** ./src/pages/preauth/Themes.jsx
 **/